import { createSlice } from '@reduxjs/toolkit'

const sendSmsSlice = createSlice({
    name: 'sendSms',
    initialState: {},
    reducers: {
        sendSms() {},
    },
})

const { actions, reducer } = sendSmsSlice

export const { sendSms } = actions

export default reducer
